import React, { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { containsPartFromArray } from "../../functions/helper";

export default function PermissionRoute({ children, permissionName, pageName = '' }) {
  const { permission, pages } = useContext(AuthContext);

  if (containsPartFromArray(permission, permissionName)) {
    return children;
  }
  else if (pages.includes(pageName) && permissionName == 'all') {
    return children;
  }
  else {
    return <Navigate to={"/firehouse/404"} replace={true} />
  }
}
